import * as betgalaxy from './MarketsByMatch.styles.betgalaxy';
import * as betprofessor from './MarketsByMatch.styles.betprofessor';
import * as betroyale from './MarketsByMatch.styles.betroyale';
import * as fiestabet from './MarketsByMatch.styles.fiestabet';
import * as puntcity from './MarketsByMatch.styles.puntcity';
import * as puntgenie from './MarketsByMatch.styles.puntgenie';
import * as questbet from './MarketsByMatch.styles.questbet';
import * as sterlingparker from './MarketsByMatch.styles.sterlingparker';
import * as vikingbet from './MarketsByMatch.styles.vikingbet';
import * as volcanobet from './MarketsByMatch.styles.volcanobet';
import * as wellbet from './MarketsByMatch.styles.wellbet';
import * as goldenrush from './MarketsByMatch.styles.goldenrush';
import * as juicybet from './MarketsByMatch.styles.juicybet';
import * as forsport from './MarketsByMatch.styles.forsport';
import * as junglebet from './MarketsByMatch.styles.junglebet';
import * as oldgill from './MarketsByMatch.styles.oldgill';
import * as buffalobet from './MarketsByMatch.styles.buffalobet';
import * as sugarcastle from './MarketsByMatch.styles.sugarcastle';
import * as gigabet from './MarketsByMatch.styles.gigabet';
import * as goldenbet888 from './MarketsByMatch.styles.goldenbet888';
import * as slambet from './MarketsByMatch.styles.slambet';
import * as betstride from './MarketsByMatch.styles.betstride';
import * as hyperbet from './MarketsByMatch.styles.hyperbet';
import * as bet777 from './MarketsByMatch.styles.bet777';
import * as chromabet from './MarketsByMatch.styles.chromabet';
import * as templebet from './MarketsByMatch.styles.templebet';
import * as titanbet from './MarketsByMatch.styles.titanbet';
import * as bet575 from './MarketsByMatch.styles.bet575';
import * as epicodds from './MarketsByMatch.styles.epicodds';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  goldenrush,
  juicybet,
  forsport,
  junglebet,
  oldgill,
  buffalobet,
  sugarcastle,
  gigabet,
  goldenbet888,
  slambet,
  betstride,
  hyperbet,
  bet777,
  chromabet,
  templebet,
  titanbet,
  epicodds,
};
